import { render, staticRenderFns } from "./BoxesRecord.vue?vue&type=template&id=090d62b7"
import script from "./BoxesRecord.vue?vue&type=script&lang=js"
export * from "./BoxesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports